export default __webpack_public_path__ + "static/media/i1.6c7b8836.png";